import { pushCart } from 'src/functions/util/dataLayer'

import type { QueryClient } from '@tanstack/react-query'
import type { Cart, UserError } from 'src/data/graphql-generated'

export const onCartMutationSuccess = (queryClient: QueryClient, cart: Cart, userErrors: UserError[]) => {
  if (userErrors.length) {
    return
  }

  if (window) {
    pushCart(cart)
  }

  queryClient.setQueryData(['cart'], cart)
}
